import React, { useState, useEffect } from 'react';
import { FormControl, Select, MenuItem, InputLabel } from '@mui/material';
import apiInstance from '../../../../services/ServiceApi'; // Asegúrate de que la ruta es correcta

function EmpresaUser({ empresaSeleccionada, setEmpresaSeleccionada }) {
    const [empresas, setEmpresas] = useState([]);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        setLoading(true);
        const fetchEmpresas = async () => {
            try {
                const response = await apiInstance.get('/empresas/');
                setEmpresas(response.data);
            } catch (error) {
                console.error('Error al cargar las empresas:', error);
            }
            finally {
            setLoading(false);
        }
        };

        fetchEmpresas();
    }, []);
    if (loading) {
        return <div>Cargando empresas...</div>;
    }
    return (
        <FormControl fullWidth>
            <InputLabel id="empresa-selector-label">Empresas</InputLabel>
            <Select
                labelId="empresa-selector-label"
                multiple
                value={empresaSeleccionada}
                onChange={(e) => setEmpresaSeleccionada(e.target.value)}
                renderValue={(selected) => 
                    selected.map(id => empresas.find(empresa => empresa.id === id)?.empresa).join(', ')
                }
            >
                {empresas.map((empresa) => (
                    <MenuItem key={empresa.id} value={empresa.id}>
                        {empresa.empresa}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}

export default EmpresaUser;
